import Store from 'redux/store';
import {
  FETCH_BANNERS,
  FETCH_BANNERS_FAIL,
  FETCH_BANNERS_SUCCESS,
} from 'redux/Reducers/Banner/BannersReducer';
import { VertemManagerEndpoint } from '../clients';

const FetchBanners = async (User, finallyCallback = () => { }, { campaign_id, catalog_id, position }) => {
  Store.dispatch({ type: FETCH_BANNERS });
  VertemManagerEndpoint(User).get(`/public/banners/campaign/${campaign_id}/${catalog_id}?active=1&position=${position}`).then((response) => {
    Store.dispatch({
      type: FETCH_BANNERS_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_BANNERS_FAIL,
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
export default FetchBanners;
